import useAgendaSocket from '../../hooks/useAgendaSocket';

/**
 * Monta la conexión de avisos en tiempo real.
 *
 * Se coloca en la raíz de la app (dentro de `PersistGate`) para que exista
 * **una sola** conexión por sesión, en lugar de una por cada cabecera o sidebar.
 * Los componentes que pintan la campana solo leen el estado de Redux.
 *
 * No necesita router ni renderiza nada.
 */
export default function AgendaSocket() {
  useAgendaSocket();
  return null;
}